import { ISlider } from './interfaces';
import { useSlider } from './slider.hooks';
import { SliderWrapper, SliderMotion } from './slider.styles';

const Slider = ({
  children,
  sliderRef,
  x,
  sliderConstraints,
  bounceStiffness,
  bounceDamping,
  visibleSliderWidth,
  singleSlideWidth,
  setActiveSlide,
  trueSliderWidth,
  activeSlide,
  childrenCount,
  margin,
}: ISlider) => {
  const { outputRadio, onDrag, onDragEnd } = useSlider({
    singleSlideWidth,
    visibleSliderWidth,
    margin,
    activeSlide,
    childrenCount,
    sliderConstraints,
    trueSliderWidth,
    x,
    setActiveSlide,
  });
  return (
    <SliderWrapper>
      <SliderMotion
        $gapSize={margin}
        ref={sliderRef}
        drag="x"
        initial={{ x: 0 }}
        style={{ x }}
        dragConstraints={{
          left: -sliderConstraints,
          right: 0,
        }}
        dragTransition={{ bounceStiffness, bounceDamping }}
        animate={{
          x: outputRadio,
        }}
        transition={{ bounceStiffness, bounceDamping }}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
      >
        {children}
      </SliderMotion>
    </SliderWrapper>
  );
};

export { Slider };
